module.exports = __webpack_public_path__ + "static/media/walrus.16fc01f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/walrus.svg
// module id = 167
// module chunks = 0